import { RegisterComponent } from '../../components/RegisterSystem/RegisterComponent'
import { HeadTitle } from '../../components/share/HeadTitle'
import { Footer } from "../../components/share/Footer";
// import { NavMenu } from "../../components/NavMenu";
import { NavbarIndexComponent } from "../../components/share/NavbarIndexComponent";

export function RegisterContainer() {
    const titleName = "ลงทะเบียนเข้าใช้งาน";
    return (
        <div className="page-container bg-landing">
            {/* <NavMenu /> */}
            <NavbarIndexComponent />
            <HeadTitle title={titleName} />
            <RegisterComponent />
            <Footer />
        </div>
    );
}